window.LusInternational.ready.then(() => {
(() => {
  const root = document.querySelector('[data-refills-collection]');
  if (!root || root.dataset.mounted === 'true') return;
  root.dataset.mounted = 'true';

  const knownScents = ['neutral', 'citrus', 'lavender', 'jasmine', 'rose'];
  const normalise = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const modelFromText = value => normalise(value).includes('wall') ? 'wall-mount' : normalise(value).includes('hand') ? 'handheld' : '';
  const modelLabel = model => model === 'wall-mount' ? 'Wall Mount' : 'Handheld';
  const push = (event, details = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, luscentra_collection: 'refills', ...details });
  };

  function readProduct(card) {
    try { return JSON.parse(card.querySelector('[data-refill-card-product]')?.textContent || '{}'); }
    catch (_) { return {}; }
  }

  function variantText(variant) {
    return normalise([variant.title, ...(variant.options || [])].join(' '));
  }

  function hasScent(product) {
    return (product.variants || []).some(variant => knownScents.some(scent => variantText(variant).includes(scent)));
  }

  function selectedVariant(product, model, scent) {
    const modelMatches = (product.variants || []).filter(variant => modelFromText(variantText(variant)) === model);
    if (!hasScent(product)) return modelMatches.find(variant => variant.available) || modelMatches[0];
    return modelMatches.find(variant => variantText(variant).includes(scent) && variant.available)
      || modelMatches.find(variant => variantText(variant).includes(scent))
      || modelMatches.find(variant => variant.available)
      || modelMatches[0];
  }

  function formatPrice(cents) {
    const currency = root.dataset.currencyCode || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency, maximumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2
      }).format(Number(cents) / 100);
    } catch (_) { return `${currency} ${(Number(cents) / 100).toFixed(2)}`; }
  }

  function state() {
    return {
      model: root.querySelector('[data-collection-model][aria-checked="true"]')?.dataset.collectionModel || 'handheld',
      scent: root.querySelector('[data-collection-scent][aria-checked="true"]')?.dataset.collectionScent || 'citrus'
    };
  }

  function check(groupSelector, active) {
    root.querySelectorAll(groupSelector).forEach(button => {
      const selected = button === active;
      button.setAttribute('aria-checked', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
  }

  function featuredImage(variant, product, model, scent) {
    const landscape = product.landscape_images?.[`${model}-${scent}`];
    if (landscape) return landscape;
    const variantImage = variant?.featured_image;
    if (typeof variantImage === 'string') return variantImage;
    if (variantImage?.src) return variantImage.src;
    return product.featured_image || product.images?.[0] || '';
  }

  function updateCard(card, model, scent) {
    const product = readProduct(card);
    const variant = selectedVariant(product, model, scent);
    const isAvailable = Boolean(variant?.available);
    card.dataset.selectedVariant = variant?.id || '';
    card.dataset.selectedAvailable = String(isAvailable);

    const price = card.querySelector('[data-refill-card-price]');
    if (price && variant?.price != null) price.textContent = (window.LusInternational.mode === 'india' ? formatPrice(variant.price) : window.LusInternational.price(variant, product));
    const sku = card.querySelector('[data-refill-card-sku]');
    if (sku) sku.textContent = variant?.sku || 'Not assigned';
    const availability = card.querySelector('[data-refill-card-availability]');
    if (availability) availability.textContent = isAvailable ? 'In stock' : 'Unavailable';
    card.querySelectorAll('[data-refill-model-label]').forEach(node => { node.textContent = modelLabel(model); });

    const image = card.querySelector('.lus-refill-card__media img');
    const imageUrl = featuredImage(variant, product, model, scent);
    if (image && imageUrl) {
      image.removeAttribute('srcset');
      image.src = imageUrl;
      image.alt = `${product.title || 'Luscentra refill'}: ${modelLabel(model)}${hasScent(product) ? `, ${scent}` : ''}`;
    }

    card.querySelectorAll('[data-refill-link]').forEach(link => {
      const url = new URL(product.url || link.href, location.origin);
      url.searchParams.set('model', model);
      if (variant?.id) url.searchParams.set('variant', variant.id);
      if (hasScent(product)) url.searchParams.set('scent', scent);
      link.href = `${url.pathname}${url.search}`;
    });

    card.querySelectorAll('[data-collection-scent-model]').forEach(node => {
      node.hidden = node.dataset.collectionScentModel !== model;
    });

    const add = card.querySelector('[data-add-refill-card]');
    if (add) {
      add.disabled = !isAvailable;
      add.setAttribute('aria-disabled', String(!isAvailable));
    }

    if (card.dataset.refillType === 'vitamin-c') {
      const guidance = card.querySelector('.lus-refill-card__guidance');
      if (guidance) guidance.textContent = model === 'wall-mount'
        ? 'Typical Wall Mount replacement guidance: 4–6 months.'
        : 'Typical Handheld replacement guidance: 2–3 months.';
    }
  }

  function writeUrl(model, scent) {
    const url = new URL(location.href);
    url.searchParams.set('model', model);
    url.searchParams.set('scent', scent);
    history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }

  function sync({ updateUrl = true } = {}) {
    const current = state();
    root.querySelectorAll('[data-collection-model-label]').forEach(node => { node.textContent = modelLabel(current.model); });
    root.querySelectorAll('[data-refill-card]').forEach(card => updateCard(card, current.model, current.scent));
    const routine = root.querySelector('[data-vitamin-routine] strong');
    if (routine) routine.textContent = current.model === 'wall-mount' ? 'Wall Mount: 4–6 months.' : 'Handheld: 2–3 months.';
    try { sessionStorage.setItem('luscentra-model', current.model); } catch (_) {}
    if (updateUrl) writeUrl(current.model, current.scent);
  }

  function initialise() {
    const query = new URLSearchParams(location.search);
    let stored = '';
    try { stored = sessionStorage.getItem('luscentra-model') || ''; } catch (_) {}
    const requested = query.get('model');
    const model = ['handheld', 'wall-mount'].includes(requested) ? requested : ['handheld', 'wall-mount'].includes(stored) ? stored : 'handheld';
    const requestedScent = normalise(query.get('scent'));
    const scent = knownScents.includes(requestedScent) ? requestedScent : 'citrus';
    const modelButton = root.querySelector(`[data-collection-model="${model}"]`);
    const scentButton = root.querySelector(`[data-collection-scent="${scent}"]`);
    if (modelButton) check('[data-collection-model]', modelButton);
    if (scentButton) check('[data-collection-scent]', scentButton);
  }

  function moveRadio(button, direction) {
    const group = button.closest('[role="radiogroup"]');
    if (!group) return;
    const radios = [...group.querySelectorAll('[role="radio"]')];
    const next = radios[(radios.indexOf(button) + direction + radios.length) % radios.length];
    next.focus();
    next.click();
  }

  root.addEventListener('keydown', event => {
    const radio = event.target.closest('[role="radio"]');
    if (!radio || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
    event.preventDefault();
    moveRadio(radio, ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1);
  });

  root.addEventListener('click', event => {
    const modelButton = event.target.closest('[data-collection-model]');
    if (modelButton) {
      check('[data-collection-model]', modelButton);
      sync();
      push('luscentra_refill_model_select', { showerhead_model: modelButton.dataset.collectionModel });
      return;
    }
    const scentButton = event.target.closest('[data-collection-scent]');
    if (scentButton) {
      check('[data-collection-scent]', scentButton);
      sync();
      push('luscentra_refill_scent_select', { scent: scentButton.dataset.collectionScent, showerhead_model: state().model });
      return;
    }
    const cardLink = event.target.closest('[data-refill-card-click]');
    if (cardLink) {
      const card = cardLink.closest('[data-refill-card]');
      push('luscentra_refill_card_click', { refill_type: card?.dataset.refillType, variant_id: card?.dataset.selectedVariant });
      return;
    }
    const crossLink = event.target.closest('[data-collection-cross-link]');
    if (crossLink) push('luscentra_collection_cross_link', { destination: crossLink.dataset.collectionCrossLink });
  });

  root.querySelectorAll('[data-add-refill-card]').forEach(button => {
    button.addEventListener('click', async () => {
      const card = button.closest('[data-refill-card]');
      const status = card.querySelector('[data-refill-card-status]');
      if (!card.dataset.selectedVariant || card.dataset.selectedAvailable !== 'true') return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Adding to your bag…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(card.dataset.selectedVariant), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Cart request failed');
        push('luscentra_refill_add_to_cart', { refill_type: card.dataset.refillType, variant_id: card.dataset.selectedVariant, ...state() });
        if (status) status.textContent = 'Added to your bag.';
      } catch (_) { if (status) status.textContent = 'We could not add this refill. Please try again.'; }
      finally { button.disabled = false; button.removeAttribute('aria-busy'); }
    });
  });

  root.querySelector('[data-add-refill-box]')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    const status = root.querySelector('[data-refill-box-status]');
    const selected = [...root.querySelectorAll('[data-box-product]:checked')];
    const items = selected.map(input => {
      const card = root.querySelector(`[data-refill-product="${CSS.escape(input.dataset.boxProduct)}"]`);
      return card?.dataset.selectedVariant && card.dataset.selectedAvailable === 'true' ? { id: Number(card.dataset.selectedVariant), quantity: 1 } : null;
    }).filter(Boolean);
    if (!items.length || items.length !== selected.length) {
      if (status) status.textContent = selected.length ? 'One or more selected refills are unavailable.' : 'Choose at least one refill.';
      return;
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Adding your refills…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart request failed');
      push('luscentra_refill_box_add', { item_count: items.length, variant_ids: items.map(item => item.id).join(','), ...state() });
      location.assign(root.dataset.cartUrl || '/cart');
    } catch (_) {
      if (status) status.textContent = 'We could not add those refills. Please try again.';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  initialise();
  sync({ updateUrl: false });
  push('luscentra_collection_view');
})();

});